/**
 * @author        yewon@zumper.com (Yewon Lee)
 * @copyright     Copyright (c) 2018, Zumper
 * @description   constants
 */

export const BEGIN_LOADING_NEARBY_HOODS = '@@nr/nearbyHoods/BEGIN_LOADING_NEARBY_HOODS'
export const ERROR_LOADING_NEARBY_HOODS = '@@nr/nearbyHoods/ERROR_LOADING_NEARBY_HOODS'
export const RECEIVE_NEARBY_HOODS = '@@nr/nearbyHoods/RECEIVE_NEARBY_HOODS'
